function EasyPeasyParallax() {
    scrollPos = $(this).scrollTop();
   // $('#fancy-heading').css({ 'background-position': '50% ' + -scrollPos / 4 + 'px' });
    $('#fancy-title').css({
        'margin-top': scrollPos / 4 + 'px',
        'opacity': 1 - scrollPos / 250
    });
}
$(document).ready(function () {
    $(window).scroll(function () {
        EasyPeasyParallax();
    });
});